
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.37 5.287L5.705 14.679a.25.25 0 00.054.473l9.065 1.813a.25.25 0 01.199.212l1.2 8.999a.25.25 0 00.472.076L26.698 5.623a.25.25 0 00-.329-.336z","stroke":"#0e193f","stroke-width":"1.5"}})])
          )
        }
      }
    